module.exports = __webpack_public_path__ + "img/kaoshigonggao.512a2edd.jpg";